(function () {
  var launchEnglish = /^en(?:-|$)/i.test(document.documentElement.lang || '');
  var launchText = function (german, english) { return launchEnglish ? english : german; };

  function initSection(root) {
    if (!root) return;
    if (root.dataset.sextInited === '1') return;
    root.dataset.sextInited = '1';

    var revealNodes = root.querySelectorAll('.reveal');
    if (revealNodes.length) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );

      revealNodes.forEach(function (node) {
        revealObserver.observe(node);
      });
    }

    var accordion = root.querySelector('[data-accordion]');
    if (accordion) {
      accordion.addEventListener('click', function (event) {
        var trigger = event.target.closest('.accordion-trigger');
        if (!trigger) return;

        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        var triggers = accordion.querySelectorAll('.accordion-trigger');
        triggers.forEach(function (item) {
          item.setAttribute('aria-expanded', 'false');
        });

        trigger.setAttribute('aria-expanded', String(!isOpen));
      });
    }

    var tabRoot = root.querySelector('[data-pricing-tabs]');
    if (tabRoot) {
      tabRoot.addEventListener('click', function (event) {
        var btn = event.target.closest('.tab-btn');
        if (!btn) return;

        var target = btn.getAttribute('data-tab-target');
        var buttons = tabRoot.querySelectorAll('.tab-btn');
        var panels = tabRoot.querySelectorAll('.tab-panel');

        buttons.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('active', active);
          b.setAttribute('aria-selected', String(active));
        });

        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-tab-panel') === target;
          panel.classList.toggle('active', active);
          panel.hidden = !active;
        });
      });
    }

    var specRoot = root.querySelector('[data-spec-categories]');
    if (specRoot) {
      var specButtons = specRoot.querySelectorAll('[data-spec-tab-target]');
      var specPanels = specRoot.querySelectorAll('[data-spec-panel]');

      var setPanelBodyOpen = function (panel, open) {
        if (!panel) return;
        var toggle = panel.querySelector('[data-spec-mobile-trigger]');
        var body = panel.querySelector('[data-spec-panel-body]');
        if (!toggle || !body) return;
        toggle.setAttribute('aria-expanded', String(open));
        body.hidden = !open;
      };

      var activateSpecPanel = function (target) {
        if (!target) return;
        specButtons.forEach(function (button) {
          var active = button.getAttribute('data-spec-tab-target') === target;
          button.classList.toggle('active', active);
          button.setAttribute('aria-selected', String(active));
        });

        specPanels.forEach(function (panel) {
          var active = panel.getAttribute('data-spec-panel') === target;
          panel.classList.toggle('active', active);
          panel.hidden = !active;
          if (active) {
            setPanelBodyOpen(panel, true);
          }
        });
      };

      specButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          activateSpecPanel(button.getAttribute('data-spec-tab-target'));
        });
      });

      specPanels.forEach(function (panel) {
        var trigger = panel.querySelector('[data-spec-mobile-trigger]');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          setPanelBodyOpen(panel, !isOpen);
        });
      });

      if (specButtons.length > 0) {
        activateSpecPanel(specButtons[0].getAttribute('data-spec-tab-target'));
      } else if (specPanels.length > 0) {
        setPanelBodyOpen(specPanels[0], true);
      }
    }

    var usecaseTabs = root.querySelector('[data-usecase-tabs]');
    if (usecaseTabs) {
      var panels = usecaseTabs.querySelectorAll('[data-usecase-tab]');
      var setActivePanel = function (panel) {
        if (!panel) return;
        panels.forEach(function (item) {
          item.classList.toggle('active', item === panel);
        });
      };

      panels.forEach(function (panel, index) {
        if (index === 0) panel.classList.add('active');

        panel.addEventListener('mouseenter', function () {
          setActivePanel(panel);
        });
        panel.addEventListener('focus', function () {
          setActivePanel(panel);
        });
        panel.addEventListener('click', function () {
          setActivePanel(panel);
        });
      });
    }

    var dynamicCardsRoot = root.querySelector('[data-hero-cards]');
    if (dynamicCardsRoot) {
      var dynamicCards = dynamicCardsRoot.querySelectorAll('[data-dynamic-card]');

      dynamicCards.forEach(function (card) {
        var resetCard = function () {
          card.style.setProperty('--card-rx', '0deg');
          card.style.setProperty('--card-ry', '0deg');
        };

        card.addEventListener('mousemove', function (event) {
          var rect = card.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          var px = (event.clientX - rect.left) / rect.width;
          var py = (event.clientY - rect.top) / rect.height;
          var ry = (px - 0.5) * 7;
          var rx = (0.5 - py) * 7;
          card.style.setProperty('--card-rx', rx.toFixed(2) + 'deg');
          card.style.setProperty('--card-ry', ry.toFixed(2) + 'deg');
        });

        card.addEventListener('mouseleave', resetCard);
        card.addEventListener('blur', resetCard, true);
      });

      var heroCardDots = root.querySelectorAll('[data-hero-card-dot]');
      if (heroCardDots.length > 0) {
        var setActiveHeroDot = function (index) {
          heroCardDots.forEach(function (dot, dotIndex) {
            dot.classList.toggle('is-active', dotIndex === index);
          });
        };

        var syncHeroDots = function () {
          if (window.innerWidth > 680) return;
          var rootRect = dynamicCardsRoot.getBoundingClientRect();
          var rootCenter = rootRect.left + rootRect.width / 2;
          var activeIndex = 0;
          var smallestDistance = Infinity;

          dynamicCards.forEach(function (card, index) {
            var rect = card.getBoundingClientRect();
            var cardCenter = rect.left + rect.width / 2;
            var distance = Math.abs(cardCenter - rootCenter);
            if (distance < smallestDistance) {
              smallestDistance = distance;
              activeIndex = index;
            }
          });

          setActiveHeroDot(activeIndex);
        };

        dynamicCardsRoot.addEventListener(
          'scroll',
          function () {
            window.requestAnimationFrame(syncHeroDots);
          },
          { passive: true }
        );

        heroCardDots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var index = Number(dot.getAttribute('data-hero-card-dot') || 0);
            var targetCard = dynamicCards[index];
            if (!targetCard) return;
            targetCard.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            setActiveHeroDot(index);
          });
        });

        syncHeroDots();
        window.addEventListener('resize', syncHeroDots);
      }
    }

    var p9CardsRoot = root.querySelector('[data-p9-cards]');
    if (p9CardsRoot) {
      var p9Cards = p9CardsRoot.querySelectorAll('[data-p9-card]');
      var selectCard = function (card) {
        p9Cards.forEach(function (item) {
          item.classList.remove('is-selected');
          item.classList.remove('is-burst');
        });
        card.classList.add('is-selected');
        card.classList.add('is-burst');
        window.setTimeout(function () {
          card.classList.remove('is-burst');
        }, 620);
      };

      p9Cards.forEach(function (card, index) {
        if (index === 0) {
          card.classList.add('is-selected');
        }

        card.addEventListener('click', function (event) {
          var cta = event.target.closest('a, button');
          if (cta) return;
          selectCard(card);
        });

        card.addEventListener('mouseenter', function () {
          selectCard(card);
        });
      });
    }

    var smoothAnchors = root.querySelectorAll('[data-scroll-target]');
    if (smoothAnchors.length) {
      smoothAnchors.forEach(function (smoothAnchor) {
        smoothAnchor.addEventListener('click', function (event) {
          var targetId = smoothAnchor.getAttribute('data-scroll-target');
          if (!targetId) return;
          event.preventDefault();
          var target = document.getElementById(targetId) || root.querySelector('#' + targetId);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }

    var stackRoot = root.querySelector('[data-stack-anim]');
    if (stackRoot) {
      var dragZone = stackRoot.querySelector('[data-stack-drag-zone]');
      var slider = root.querySelector('[data-stack-slider]');
      var stageGrid = stackRoot.querySelector('[data-p5-stage-grid]');
      var towerSlots = stackRoot.querySelectorAll('[data-p5-slot]');
      var parallelNoteNode = root.querySelector('[data-p5-parallel-note]');
      var modeButtons = root.querySelectorAll('[data-p5-mode]');
      var towerButtons = root.querySelectorAll('[data-p5-towers-option]');
      var stageModeLabelNode = root.querySelector('[data-p5-stage-mode-label]');
      var capacityNode = stackRoot.querySelector('[data-capacity]');
      var powerNode = stackRoot.querySelector('[data-power]');
      var capacitySummaryNode = root.querySelector('[data-capacity-summary]');
      var powerSummaryNode = root.querySelector('[data-power-summary]');
      var towersSummaryNode = root.querySelector('[data-p5-towers-summary]');
      var mpptSummaryNode = root.querySelector('[data-p5-mppt-summary]');
      var gridSummaryNode = root.querySelector('[data-p5-grid-summary]');
      var connectionSummaryNode = root.querySelector('[data-p5-connection-summary]');
      var levelNodes = root.querySelectorAll('[data-level-label]');
      var levelData = Array.prototype.map.call(levelNodes, function (node) {
        return {
          capacity: node.getAttribute('data-capacity') || '',
          power: node.getAttribute('data-power') || '',
          stackCount: Number(node.getAttribute('data-stack-count') || 0)
        };
      });
      var maxLevel = Math.max(6, levelData.length || 0);
      var currentLevel = 1;
      var currentTowers = 1;
      var userInteracted = false;
      var currentMode = 'scale';
      var modeLabels = {
        scale: stackRoot.getAttribute('data-p5-mode-scale-label') || launchText('Parallel skalieren', "Scale in parallel"),
        threephase: stackRoot.getAttribute('data-p5-mode-threephase-label') || launchText('Dreiphasig', "Three-phase")
      };
      var optionalCableLabel =
        stackRoot.getAttribute('data-p5-optional-cable-label') ||
        launchText('Zusätzliches Verbindungskabel bei mehreren Türmen', "Additional connection cable for multiple towers");
      var threePhasePowerLabel =
        stackRoot.getAttribute('data-p5-threephase-power') || '22 kVA Off-Grid';
      var threePhaseGridLabel =
        stackRoot.getAttribute('data-p5-threephase-grid') || launchText('Dreiphasig', "Three-phase");
      var phaseLabels = ['Phase A', 'Phase B', 'Phase C'];

      var parseMetric = function (valueText) {
        var text = String(valueText || '').trim();
        var match = text.match(/^([0-9][0-9\.,]*)\s*(.*)$/);
        if (!match) return null;
        var numeric = Number(match[1].replace(/\./g, '').replace(',', '.'));
        if (!Number.isFinite(numeric)) return null;
        return { value: numeric, unit: (match[2] || '').trim() };
      };

      var formatGermanNumber = function (num) {
        var rounded = Math.round(num * 100) / 100;
        if (Number.isInteger(rounded)) {
          return String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        }
        return rounded.toFixed(2).replace('.', ',');
      };

      var resolveLevelData = function (level) {
        if (!levelData.length) {
          return { stackCount: Math.max(0, level - 1), capacity: String(level * 5) + ' kWh', power: '2.400 W' };
        }
        var exact = levelData[level - 1];
        if (exact) return exact;
        return levelData[levelData.length - 1];
      };

      var multiplyMetric = function (valueText, multiplier) {
        var parsed = parseMetric(valueText);
        if (!parsed) return valueText;
        return formatGermanNumber(parsed.value * multiplier) + (parsed.unit ? ' ' + parsed.unit : '');
      };

      var setButtonGroup = function (buttons, activeValue, attributeName) {
        buttons.forEach(function (button) {
          var active = String(button.getAttribute(attributeName)) === String(activeValue);
          button.classList.toggle('active', active);
          button.setAttribute('aria-selected', String(active));
        });
      };

      var updateTowerVisuals = function (level, isThreePhase) {
        var combinedMainOnly =
          !isThreePhase &&
          level === 1 &&
          currentTowers > 1 &&
          !!stackRoot.querySelector('[data-p5-mainonly-image="' + currentTowers + '"]');
        var visibleTowers = isThreePhase ? 9 : combinedMainOnly ? 1 : currentTowers;
        var displayLevel = isThreePhase ? maxLevel : level;
        if (stageGrid) {
          stageGrid.classList.toggle('is-threephase', isThreePhase);
          stageGrid.classList.toggle('is-mainonly', combinedMainOnly);
        }

        towerSlots.forEach(function (slot, index) {
          var slotNumber = index + 1;
          var isVisible = slotNumber <= visibleTowers;
          slot.classList.toggle('is-hidden', !isVisible);
          slot.classList.toggle('is-threephase', isThreePhase);
          slot.classList.toggle('is-ghost', isThreePhase && slotNumber > 3);

          var groupLabel = slot.querySelector('[data-p5-group-label]');
          var slotCaption = slot.querySelector('[data-p5-slot-caption]');
          if (groupLabel) {
            if (isThreePhase) {
              groupLabel.textContent = phaseLabels[Math.ceil(slotNumber / 3) - 1] || '';
            } else if (combinedMainOnly && slotNumber === 1) {
              groupLabel.textContent = currentTowers + launchText('× Hauptgerät', "× main unit");
            } else if (currentTowers > 1) {
              groupLabel.textContent = 'Parallel';
            } else {
              groupLabel.textContent = '';
            }
          }
          if (slotCaption) {
            if (combinedMainOnly && slotNumber === 1) {
              slotCaption.textContent = currentTowers + launchText(' gekoppelte Hauptgeräte', " coupled main units");
            } else {
              slotCaption.textContent = launchText('Turm ', "Tower ") + slotNumber;
            }
          }

          var slotFrames = slot.querySelectorAll('[data-p5-image-level]');
          var mainOnlyFrames = slot.querySelectorAll('[data-p5-mainonly-image]');
          mainOnlyFrames.forEach(function (frame) {
            var towersValue = Number(frame.getAttribute('data-p5-mainonly-image') || 0);
            frame.classList.toggle('active', combinedMainOnly && slotNumber === 1 && towersValue === currentTowers);
          });
          slotFrames.forEach(function (frame) {
            var frameLevel = Number(frame.getAttribute('data-p5-image-level') || 1);
            frame.classList.toggle('active', !combinedMainOnly && frameLevel === displayLevel);
          });
        });
      };

      var setLevel = function (level) {
        currentLevel = Math.max(1, Math.min(maxLevel, Number(level) || 1));
        var current = resolveLevelData(currentLevel);
        var isThreePhase = currentMode === 'threephase';
        var displayedLevel = isThreePhase ? maxLevel : currentLevel;

        levelNodes.forEach(function (node) {
          node.classList.toggle('active', Number(node.getAttribute('data-level-label')) === displayedLevel);
        });

        if (slider) {
          slider.value = String(displayedLevel);
          slider.max = String(maxLevel);
          slider.disabled = isThreePhase;
        }

        if (stageModeLabelNode) {
          stageModeLabelNode.textContent = isThreePhase ? modeLabels.threephase : modeLabels.scale;
        }

        updateTowerVisuals(displayedLevel, isThreePhase);
        setButtonGroup(towerButtons, currentTowers, 'data-p5-towers-option');

        var capacityDisplay = '';
        var powerDisplay = '';
        var towersDisplay = '';
        var mpptDisplay = '';
        var gridDisplay = '';
        var connectionDisplay = '';

        if (isThreePhase) {
          capacityDisplay = multiplyMetric(resolveLevelData(maxLevel).capacity, 9);
          powerDisplay = threePhasePowerLabel;
          towersDisplay = '9';
          mpptDisplay = '36× MPPT';
          gridDisplay = threePhaseGridLabel;
          connectionDisplay = launchText('3 gekoppelte Dreiergruppen', "3 coupled groups of three");
        } else {
          capacityDisplay = multiplyMetric(current.capacity, currentTowers);
          powerDisplay = multiplyMetric(current.power, currentTowers);
          towersDisplay = String(currentTowers);
          mpptDisplay = String(currentTowers * 4) + '× MPPT';
          gridDisplay = currentTowers > 1 ? launchText('Parallelbetrieb', "Parallel operation") : launchText('Einzelturm', "Single tower");
          connectionDisplay = currentTowers > 1 ? optionalCableLabel : launchText('Kein Zusatzkabel', "No additional cable");
        }

        if (capacityNode) capacityNode.textContent = capacityDisplay || current.capacity;
        if (powerNode) powerNode.textContent = powerDisplay || current.power;
        if (capacitySummaryNode) capacitySummaryNode.textContent = capacityDisplay || current.capacity;
        if (powerSummaryNode) powerSummaryNode.textContent = powerDisplay || current.power;
        if (towersSummaryNode) towersSummaryNode.textContent = towersDisplay;
        if (mpptSummaryNode) mpptSummaryNode.textContent = mpptDisplay;
        if (gridSummaryNode) gridSummaryNode.textContent = gridDisplay;
        if (connectionSummaryNode) connectionSummaryNode.textContent = connectionDisplay;

        if (parallelNoteNode) {
          parallelNoteNode.classList.add('active');
          parallelNoteNode.textContent = isThreePhase
            ? launchText('Im dreiphasigen Ausbau koppeln sich drei Turmgruppen zu einem Gesamtsystem. Dadurch wachsen Kapazität, MPPT-Struktur und Systemleistung gemeinsam.', "In a three-phase expansion, three groups of towers are coupled into one system. Capacity, MPPT configuration and system power increase together.")
            : currentTowers > 1 && currentLevel === 1
              ? launchText('Mehrere Hauptgeräte lassen sich direkt koppeln. Schon ohne Erweiterungsbatterien wächst dadurch nicht nur die Kapazität, sondern auch die Systemleistung.', "Multiple main units can be coupled directly. This increases both capacity and system power, even without expansion batteries.")
            : currentTowers > 1
              ? launchText('Mehrere Türme koppeln nicht nur zusätzliche Kapazität, sondern skalieren auch MPPT-Leistung und bidirektionale Wechselrichterleistung im System.', "Coupling multiple towers adds capacity and also increases the MPPT power and bidirectional inverter power of the system.")
              : launchText('Ein Turm besteht aus einem Hauptgerät und bis zu fünf Erweiterungsbatterien. So wächst das System von 5 kWh bis 30 kWh pro Turm.', "A tower consists of one main unit and up to five expansion batteries. This increases the system from 5 kWh to 30 kWh per tower.");
        }
      };

      var updateByScroll = function () {
        if (userInteracted || currentMode === 'threephase') return;

        var rect = stackRoot.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var start = vh * 0.55;
        var end = -Math.max(rect.height * 0.55, vh * 0.35);

        if (rect.top > start) {
          setLevel(1);
          return;
        }

        if (rect.top < end) {
          setLevel(maxLevel);
          return;
        }

        var raw = (start - rect.top) / (start - end);
        var clamped = Math.max(0, Math.min(1, raw));

        // Ease-in-out so the sequence advances smoothly and gives users time to read each level.
        var eased =
          clamped < 0.5
            ? 2 * clamped * clamped
            : 1 - Math.pow(-2 * clamped + 2, 2) / 2;

        var level = Math.max(1, Math.min(maxLevel, Math.floor(eased * maxLevel) + 1));
        setLevel(level);
      };

      var activateUserControl = function () {
        userInteracted = true;
      };

      if (slider) {
        slider.addEventListener('input', function () {
          activateUserControl();
          setLevel(slider.value);
        });
      }

      modeButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          currentMode = button.getAttribute('data-p5-mode') || 'scale';
          modeButtons.forEach(function (item) {
            var active = item === button;
            item.classList.toggle('active', active);
            item.setAttribute('aria-selected', String(active));
          });
          activateUserControl();
          setLevel(currentLevel);
        });
      });

      towerButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          currentTowers = Number(button.getAttribute('data-p5-towers-option') || 1);
          activateUserControl();
          setLevel(currentLevel);
        });
      });

      levelNodes.forEach(function (node) {
        node.addEventListener('click', function () {
          var selected = Number(node.getAttribute('data-level-label') || 1);
          activateUserControl();
          setLevel(selected);
        });
      });

      if (dragZone) {
        var dragging = false;
        var updateFromPointer = function (clientX) {
          if (currentMode === 'threephase') return;
          var rect = dragZone.getBoundingClientRect();
          if (!rect.width) return;
          var x = Math.max(0, Math.min(rect.width, clientX - rect.left));
          var ratio = x / rect.width;
          var level = Math.max(1, Math.min(maxLevel, Math.round(ratio * (maxLevel - 1)) + 1));
          setLevel(level);
        };

        dragZone.addEventListener('pointerdown', function (event) {
          dragging = true;
          activateUserControl();
          updateFromPointer(event.clientX);
          if (dragZone.setPointerCapture) {
            dragZone.setPointerCapture(event.pointerId);
          }
        });

        dragZone.addEventListener('pointermove', function (event) {
          if (!dragging) return;
          updateFromPointer(event.clientX);
        });

        var stopDrag = function () {
          dragging = false;
        };
        dragZone.addEventListener('pointerup', stopDrag);
        dragZone.addEventListener('pointercancel', stopDrag);
      }

      updateByScroll();
      window.addEventListener('scroll', updateByScroll, { passive: true });
      window.addEventListener('resize', updateByScroll);
      setLevel(currentLevel);
    }

    var p5v2Root = root.querySelector('[data-p5v2]');
    if (p5v2Root) {
      var p5v2Slider = root.querySelector('[data-p5v2-capacity-slider]');
      var p5v2Over90Button = root.querySelector('[data-p5v2-over-90-toggle]');
      var p5v2PowerButtons = root.querySelectorAll('[data-p5v2-power]');
      var p5v2TargetNode = root.querySelector('[data-p5v2-capacity-target]');
      var p5v2BadgeNode = root.querySelector('[data-p5v2-stage-badge]');
      var p5v2CapacityStageNode = root.querySelector('[data-p5v2-capacity-stage]');
      var p5v2PowerStageNode = root.querySelector('[data-p5v2-power-stage]');
      var p5v2SummaryCapacityNode = root.querySelector('[data-p5v2-summary-capacity]');
      var p5v2SummaryPowerNode = root.querySelector('[data-p5v2-summary-power]');
      var p5v2SummaryLayoutNode = root.querySelector('[data-p5v2-summary-layout]');
      var p5v2SummaryTowersNode = root.querySelector('[data-p5v2-summary-towers]');
      var p5v2SummaryMpptNode = root.querySelector('[data-p5v2-summary-mppt]');
      var p5v2SummaryGridNode = root.querySelector('[data-p5v2-summary-grid]');
      var p5v2SummaryConnectionNode = root.querySelector('[data-p5v2-summary-connection]');
      var p5v2SummaryReleaseNode = root.querySelector('[data-p5v2-summary-release]');
      var p5v2RecommendationTitleNode = root.querySelector('[data-p5v2-recommendation-title]');
      var p5v2RecommendationBodyNode = root.querySelector('[data-p5v2-recommendation-body]');
      var p5v2PowerNoteNode = root.querySelector('[data-p5v2-power-note]');
      var p5v2LinkedRouteNode = root.querySelector('[data-p5v2-linked-route]');
      var p5v2LinkedCapacityNode = root.querySelector('[data-p5v2-linked-capacity]');
      var p5v2ProductLinkNode = root.querySelector('[data-p5v2-product-link]');
      var p5v2StageGrid = root.querySelector('[data-p5v2-stage-grid]');
      var p5v2Slots = root.querySelectorAll('[data-p5v2-slot]');
      var p5v2OverlayNode = root.querySelector('[data-p5v2-overlay]');

      var over90Label = p5v2Root.getAttribute('data-p5v2-over-90-label') || launchText('Mehr als 90 kWh', "More than 90 kWh");
      var over90Note = p5v2Root.getAttribute('data-p5v2-over-90-note') || launchText('Dreiphasiges System bis 270 kWh · Coming Soon im Juni 2026', "Three-phase system up to 270 kWh · Coming soon in June 2026");
      var powerLabels = {
        standard: p5v2Root.getAttribute('data-p5v2-standard-label') || 'Standard',
        performance: p5v2Root.getAttribute('data-p5v2-performance-label') || launchText('Mehr Leistung', "More power"),
        max: p5v2Root.getAttribute('data-p5v2-max-label') || 'Maximum'
      };
      var powerTexts = {
        standard: p5v2Root.getAttribute('data-p5v2-power-standard-text') || '',
        performance: p5v2Root.getAttribute('data-p5v2-power-performance-text') || '',
        max: p5v2Root.getAttribute('data-p5v2-power-max-text') || ''
      };
      var connectionSingle = p5v2Root.getAttribute('data-p5v2-connection-single') || launchText('Keine Zusatzverbindung nötig', "No additional connection required");
      var connectionMulti = p5v2Root.getAttribute('data-p5v2-connection-multi') || launchText('Zusätzliches Verbindungskabel', "Additional connection cable");
      var threephaseGrid = p5v2Root.getAttribute('data-p5v2-threephase-grid') || launchText('Dreiphasig', "Three-phase");
      var threephasePower = p5v2Root.getAttribute('data-p5v2-threephase-power') || '22 kVA Off-Grid';
      var threephaseNote = p5v2Root.getAttribute('data-p5v2-threephase-note') || over90Note;
      var releaseStandard = p5v2Root.getAttribute('data-p5v2-release-standard') || launchText('Konfiguration technisch prüfen', "Technical configuration check required");
      var releaseThreephase = p5v2Root.getAttribute('data-p5v2-release-threephase') || over90Note;
      var consultLink = p5v2Root.getAttribute('data-p5v2-consult-link') || '';
      var consultButton = p5v2Root.getAttribute('data-p5v2-consult-button') || launchText('Technische Beratung anfragen', "Request technical advice");
      var syncWithAdvisor = p5v2Root.getAttribute('data-p5v2-linked') === 'true';
      var hasMainOnlyImages = {
        2: p5v2Root.getAttribute('data-p5v2-has-main-only-2') === 'true',
        3: p5v2Root.getAttribute('data-p5v2-has-main-only-3') === 'true'
      };
      var adaptiveVisualHeight = p5v2Root.getAttribute('data-p5v2-adaptive-height') === 'true';
      var desktopVisualMinHeight = Number(p5v2Root.getAttribute('data-p5v2-desktop-min-height')) || 460;
      var desktopVisualMaxHeight = Number(p5v2Root.getAttribute('data-p5v2-desktop-max-height')) || 640;
      var mobileVisualMinHeight = Number(p5v2Root.getAttribute('data-p5v2-mobile-min-height')) || 360;
      var mobileVisualMaxHeight = Number(p5v2Root.getAttribute('data-p5v2-mobile-max-height')) || 540;
      desktopVisualMaxHeight = Math.max(desktopVisualMinHeight, desktopVisualMaxHeight);
      mobileVisualMaxHeight = Math.max(mobileVisualMinHeight, mobileVisualMaxHeight);
      var phaseLabelsV2 = ['Phase A', 'Phase B', 'Phase C'];

      var p5v2State = {
        targetCapacity: Number(p5v2Slider ? p5v2Slider.value : 5),
        powerPreference: 'standard',
        over90: false,
        route: '',
        routeLabel: '',
        gridPowerPerUnit: 2400,
        backupPowerPerUnit: 2400,
        requiresConsultation: false,
        productLink: '',
        productButton: ''
      };

      var formatGermanNumberV2 = function (num) {
        var rounded = Math.round(num * 100) / 100;
        if (Number.isInteger(rounded)) {
          return String(rounded).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        }
        return rounded.toFixed(2).replace('.', ',');
      };

      var setP5v2PowerButtons = function () {
        p5v2PowerButtons.forEach(function (button) {
          var value = button.getAttribute('data-p5v2-power') || 'standard';
          var active = value === p5v2State.powerPreference;
          button.classList.toggle('active', active);
          button.setAttribute('aria-selected', String(active));
        });
      };

      var updateP5v2Visual = function (towers, moduleDistribution, over90) {
        if (!p5v2StageGrid) return;
        var showMainOnly =
          !over90 &&
          towers > 1 &&
          hasMainOnlyImages[towers] &&
          moduleDistribution.every(function (count) { return count === 1; });
        var maximumLevel = over90
          ? 6
          : Math.max.apply(null, moduleDistribution.length ? moduleDistribution : [1]);
        var heightProgress = adaptiveVisualHeight ? Math.max(0, Math.min(1, (maximumLevel - 1) / 5)) : 0;
        var desktopHeight = Math.round(desktopVisualMinHeight + (desktopVisualMaxHeight - desktopVisualMinHeight) * heightProgress);
        var mobileHeight = Math.round(mobileVisualMinHeight + (mobileVisualMaxHeight - mobileVisualMinHeight) * heightProgress);
        p5v2Root.style.setProperty('--p5-stage-height-desktop', desktopHeight + 'px');
        p5v2Root.style.setProperty('--p5-stage-height-mobile', mobileHeight + 'px');
        p5v2StageGrid.setAttribute('data-p5v2-max-level', String(maximumLevel));
        p5v2StageGrid.classList.toggle('is-mainonly', showMainOnly);
        p5v2StageGrid.classList.toggle('is-threephase', over90);

        p5v2Slots.forEach(function (slot, index) {
          var slotNumber = index + 1;
          var visibleSlots = over90 ? 9 : showMainOnly ? 1 : towers;
          var visible = slotNumber <= visibleSlots;
          slot.classList.toggle('is-hidden', !visible);
          slot.classList.toggle('is-threephase', over90);
          slot.classList.toggle('is-ghost', over90 && slotNumber > 3);

          var groupLabel = slot.querySelector('[data-p5v2-group-label]');
          var caption = slot.querySelector('[data-p5v2-slot-caption]');
          if (groupLabel) {
            if (over90) {
              groupLabel.textContent = phaseLabelsV2[Math.ceil(slotNumber / 3) - 1] || '';
            } else if (showMainOnly && slotNumber === 1) {
              groupLabel.textContent = towers + launchText('× Hauptgerät', "× main unit");
            } else if (towers > 1) {
              groupLabel.textContent = 'Parallel';
            } else {
              groupLabel.textContent = '';
            }
          }
          if (caption) {
            caption.textContent = showMainOnly && slotNumber === 1 ? towers + launchText(' gekoppelte Hauptgeräte', " coupled main units") : launchText('Turm ', "Tower ") + slotNumber;
          }

          var mainOnlyFrames = slot.querySelectorAll('[data-p5-mainonly-image]');
          mainOnlyFrames.forEach(function (frame) {
            var frameTowers = Number(frame.getAttribute('data-p5-mainonly-image') || 0);
            frame.classList.toggle('active', showMainOnly && slotNumber === 1 && frameTowers === towers);
          });

          var towerFrames = slot.querySelectorAll('[data-p5-image-level]');
          towerFrames.forEach(function (frame) {
            var frameLevel = Number(frame.getAttribute('data-p5-image-level') || 1);
            var expectedLevel = over90 ? 6 : (moduleDistribution[index] || 1);
            frame.classList.toggle('active', !showMainOnly && frameLevel === expectedLevel);
          });
        });
      };

      var distributeUnitsAcrossTowers = function (unitCount, towers) {
        var base = Math.floor(unitCount / towers);
        var remainder = unitCount % towers;
        var result = [];

        for (var i = 0; i < towers; i += 1) {
          result.push(base + (i < remainder ? 1 : 0));
        }

        return result;
      };

      var computeP5v2 = function () {
        var target = p5v2State.targetCapacity;
        var over90 = p5v2State.over90;
        var towers = 1;
        var moduleDistribution = [1];
        var effectiveCapacity = target;

        if (over90) {
          towers = 9;
          effectiveCapacity = 270;
          moduleDistribution = [6, 6, 6, 6, 6, 6, 6, 6, 6];
        } else {
          var minimumTowers = Math.ceil(target / 30);
          var desiredTowers =
            p5v2State.powerPreference === 'max'
              ? 3
              : p5v2State.powerPreference === 'performance'
                ? 2
                : 1;
          towers = Math.max(minimumTowers, desiredTowers);
          towers = Math.min(3, towers);
          effectiveCapacity = Math.max(target, towers * 5);
          var totalUnits = Math.round(effectiveCapacity / 5);
          moduleDistribution = distributeUnitsAcrossTowers(totalUnits, towers);

          p5v2State.targetCapacity = effectiveCapacity;
          if (p5v2Slider) {
            p5v2Slider.value = String(effectiveCapacity);
          }
        }

        var actualCapacity = over90 ? 270 : effectiveCapacity;
        var actualPower = over90
          ? threephasePower
          : formatGermanNumberV2(towers * p5v2State.gridPowerPerUnit) + launchText(' W Netzeinspeisung · ', " W grid feed-in · ") +
            formatGermanNumberV2(towers * p5v2State.backupPowerPerUnit) + ' W Backup';
        var mpptTotal = over90 ? '36× MPPT' : String(towers * 4) + '× MPPT';
        var gridType = over90 ? threephaseGrid : towers > 1 ? launchText('Einphasig / Parallel', "Single-phase / parallel") : launchText('Einphasig', "Single-phase");
        var connectionType = over90 ? launchText('Dreiphasige Systemkopplung', "Three-phase system coupling") : towers > 1 ? connectionMulti : connectionSingle;
        var release = over90 ? releaseThreephase : releaseStandard;

        var layoutText = '';
        if (over90) {
          layoutText = launchText('9 Türme mit je 1 Hauptgerät + 5 B500', "9 towers, each with 1 main unit + 5 B500");
        } else if (moduleDistribution.every(function (count) { return count === 1; })) {
          layoutText = towers === 1 ? launchText('1 Hauptgerät', "1 main unit") : towers + launchText(' Hauptgeräte', " main units");
        } else {
          layoutText = moduleDistribution
            .map(function (count) {
              return count === 1 ? launchText('1 Hauptgerät', "1 main unit") : launchText('1 Hauptgerät + ', "1 main unit + ") + (count - 1) + ' B500';
            })
            .join(' / ');
        }

        var recommendationTitle = '';
        var recommendationBody = '';
        if (over90) {
          recommendationTitle = launchText('Für mehr als 90 kWh wechseln wir in die dreiphasige Architektur.', "Above 90 kWh, we switch to a three-phase architecture.");
          recommendationBody = threephaseNote;
        } else if (towers === 1) {
          recommendationTitle = launchText('Ein Hauptgerät deckt Deinen Bedarf wirtschaftlich ab.', "One main unit meets your needs economically.");
          recommendationBody = launchText('Für Dein Ziel reichen ein Hauptgerät und ', "Your target can be met with one main unit and ") + Math.max(0, moduleDistribution[0] - 1) + launchText(' Erweiterungsbatterien. Du bleibst kompakt und kannst später jederzeit auf mehr Leistung erweitern.', (Math.max(0, moduleDistribution[0] - 1) === 1 ? " expansion battery." : " expansion batteries.") + " The setup stays compact and can be expanded for more power later.");
        } else if (towers === 2) {
          recommendationTitle = launchText('Zwei Hauptgeräte sind der passende Kompromiss aus Kapazität und Leistung.', "Two main units provide a balance of capacity and power.");
          recommendationBody = launchText('Damit verteilst Du die gewünschte Kapazität auf zwei Türme (', "This distributes your target capacity across two towers (") + moduleDistribution.map(function (count) { return count * 5 + ' kWh'; }).join(' + ') + launchText(') und erhältst gleichzeitig mehr MPPT- und Wechselrichterleistung für anspruchsvollere Lastprofile.', ") while providing more MPPT and inverter power for more demanding load profiles.");
        } else {
          recommendationTitle = launchText('Drei Hauptgeräte priorisieren maximale Leistungsreserven.', "Three main units prioritise maximum power reserves.");
          recommendationBody = launchText('Diese Konfiguration verteilt Deine Zielkapazität auf drei Türme (', "This configuration distributes your target capacity across three towers (") + moduleDistribution.map(function (count) { return count * 5 + ' kWh'; }).join(' + ') + launchText(') und priorisiert maximale Leistungsreserven sowie mehr MPPT-Kanäle.', ") and prioritises maximum power reserves and more MPPT channels.");
        }

        if (p5v2TargetNode) p5v2TargetNode.textContent = (over90 ? '>90 kWh' : effectiveCapacity + ' kWh');
        if (p5v2BadgeNode) p5v2BadgeNode.textContent = over90 ? over90Label : actualCapacity + launchText(' empfohlen', " recommended");
        if (p5v2CapacityStageNode) p5v2CapacityStageNode.textContent = actualCapacity + ' kWh';
        if (p5v2PowerStageNode) p5v2PowerStageNode.textContent = actualPower;
        if (p5v2SummaryCapacityNode) p5v2SummaryCapacityNode.textContent = actualCapacity + ' kWh';
        if (p5v2SummaryPowerNode) p5v2SummaryPowerNode.textContent = actualPower;
        if (p5v2SummaryLayoutNode) p5v2SummaryLayoutNode.textContent = layoutText;
        if (p5v2SummaryTowersNode) p5v2SummaryTowersNode.textContent = String(towers);
        if (p5v2SummaryMpptNode) p5v2SummaryMpptNode.textContent = mpptTotal;
        if (p5v2SummaryGridNode) p5v2SummaryGridNode.textContent = gridType;
        if (p5v2SummaryConnectionNode) p5v2SummaryConnectionNode.textContent = connectionType;
        if (p5v2SummaryReleaseNode) p5v2SummaryReleaseNode.textContent = release;
        if (p5v2RecommendationTitleNode) p5v2RecommendationTitleNode.textContent = recommendationTitle;
        if (p5v2RecommendationBodyNode) p5v2RecommendationBodyNode.textContent = recommendationBody;
        if (p5v2PowerNoteNode) p5v2PowerNoteNode.textContent = powerTexts[p5v2State.powerPreference] || '';
        if (p5v2LinkedRouteNode && p5v2State.routeLabel) p5v2LinkedRouteNode.textContent = p5v2State.routeLabel;
        if (p5v2LinkedCapacityNode && p5v2State.routeLabel) {
          p5v2LinkedCapacityNode.textContent = actualCapacity + ' kWh · ' + towers + (towers === 1 ? launchText(' Hauptgerät', " main unit") : launchText(' Hauptgeräte', " main units"));
        }
        if (p5v2ProductLinkNode) {
          if (p5v2State.requiresConsultation && consultLink) {
            p5v2ProductLinkNode.href = consultLink;
            p5v2ProductLinkNode.textContent = consultButton;
          } else if (p5v2State.productLink) {
            p5v2ProductLinkNode.href = p5v2State.productLink;
            if (p5v2State.productButton) p5v2ProductLinkNode.textContent = p5v2State.productButton;
          }
        }
        if (p5v2OverlayNode) p5v2OverlayNode.textContent = over90 ? over90Note : connectionType;
        if (p5v2Over90Button) {
          p5v2Over90Button.classList.toggle('is-active', over90);
          p5v2Over90Button.setAttribute('data-p5v2-over-90-toggle', String(over90));
        }

        updateP5v2Visual(towers, moduleDistribution, over90);
      };

      if (p5v2Slider) {
        p5v2Slider.addEventListener('input', function () {
          p5v2State.targetCapacity = Number(p5v2Slider.value || 5);
          p5v2State.over90 = false;
          computeP5v2();
        });
      }

      if (p5v2Over90Button) {
        p5v2Over90Button.addEventListener('click', function () {
          p5v2State.over90 = !p5v2State.over90;
          computeP5v2();
        });
      }

      p5v2PowerButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          p5v2State.powerPreference = button.getAttribute('data-p5v2-power') || 'standard';
          setP5v2PowerButtons();
          computeP5v2();
        });
      });

      var applyAdvisorState = function (advisorState) {
        if (!syncWithAdvisor || !advisorState) return;

        var recommendedCapacity = Math.max(5, Math.min(90, Number(advisorState.capacity) || 5));
        var recommendedMainUnits = Math.max(1, Math.min(3, Number(advisorState.mainUnitCount) || 1));
        p5v2State.targetCapacity = recommendedCapacity;
        p5v2State.powerPreference = recommendedMainUnits >= 3 ? 'max' : recommendedMainUnits === 2 ? 'performance' : 'standard';
        p5v2State.over90 = false;
        p5v2State.route = advisorState.route || '';
        p5v2State.routeLabel = advisorState.routeLabel || advisorState.title || '';
        p5v2State.gridPowerPerUnit = Number(advisorState.gridPowerPerUnit) || 2400;
        p5v2State.backupPowerPerUnit = Number(advisorState.backupPowerPerUnit) || 2400;
        p5v2State.requiresConsultation = !!advisorState.requiresConsultation;
        p5v2State.productLink = advisorState.productLink || '';
        p5v2State.productButton = advisorState.productButton || '';

        if (p5v2Slider) p5v2Slider.value = String(recommendedCapacity);
        setP5v2PowerButtons();
        computeP5v2();
      };

      window.addEventListener('drbo:500-advisor:update', function (event) {
        applyAdvisorState(event.detail);
      });

      setP5v2PowerButtons();
      if (syncWithAdvisor && window.DRBO500AdvisorState) {
        applyAdvisorState(window.DRBO500AdvisorState);
      } else {
        computeP5v2();
      }
    }

    var heroMedia = root.querySelector('.sext-hero-media');
    if (heroMedia) {
      var parallax = function () {
        var y = window.scrollY || window.pageYOffset;
        heroMedia.style.transform = 'translateY(' + Math.max(-10, y * -0.03) + 'px)';
      };
      parallax();
      window.addEventListener('scroll', parallax, { passive: true });
    }
  }

  function initAll(scope) {
    var searchRoot = scope || document;
    var sections = searchRoot.querySelectorAll('.sext-launch');
    sections.forEach(initSection);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) {
      initAll(event.target);
      if (event.target.classList && event.target.classList.contains('sext-launch')) {
        initSection(event.target);
      }
    } else {
      initAll(document);
    }
  });
})();
